<template>
    <div class="goodBook">
        <div class="img">
            <img :src="data.cover" alt="">
        </div>
        <div class="text">
            <div class="title" v-text="data.name">{{}}</div>
            <p>
                <span class="money" v-text="'￥' + data.price"></span>
                <span class="number" v-text="data.shopper + '人付款'"></span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
  name: "goodBook",
  data() {
    return {};
  },
  props: ["data"]
};
</script>

<style scoped lang="scss">
.goodBook {
  width: 100%;
  font-size: 20px;
  .img {
    width: 100%;
    height: auto;
    /*background: aqua;*/
    box-sizing: border-box;
    border: 1PX solid #d2d2d2;
    img {
      display: block;
    }
  }
  .text {
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-line-clamp: 1;
      font-size: 26px;
      line-height: 1.2;
      color: #333;
      margin-top: 22px;
    }
    p {
      overflow: hidden;
      position: relative;
      margin-top: 20px;
      .money {
        font-size: 26px;
        color: #d2423d;
        line-height: 1;
      }
      .number {
        position: absolute;
        bottom: 2px;
        right: 0;
        font-size: 20px;
        color: #999999;
        line-height: 1;
        margin-right: 10px;
      }
    }
  }
}
</style>
